module.exports = __webpack_public_path__ + "assets/fonts/GothamPro.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro.ttf
// module id = 681
// module chunks = 0